enum SubscriptionType {
  STARTER = "Starter",
  PRO = "Pro",
  ULTRA = "Ultra",
  FREE_TRIAL = "FreeTrial",
}

export default SubscriptionType;
